const t = "_root_oue07_1", o = "_alignLeft_oue07_8", _ = "_alignRight_oue07_12", a = "_card_oue07_16", n = {
  root: t,
  alignLeft: o,
  alignRight: _,
  card: a
};
export {
  o as alignLeft,
  _ as alignRight,
  a as card,
  n as default,
  t as root
};
//# sourceMappingURL=index.es801.js.map
